import { useEffect } from 'react';
import { floraMessage } from '@grupoboticario/flora-react-utils';
export var useFloraTypography = children => {
  useEffect(() => {
    if (typeof children === 'string' && children.length > 80) {
      floraMessage({
        type: 'log',
        category: 'accessibility',
        status: 'warn',
        message: "O texto do componente FloraTypography possui mais de 80 caracteres. Considere dividir o texto em par\xE1grafos menores para melhorias em acessibilidade."
      });
    }
  }, [children]);
};
//# sourceMappingURL=useFloraTypography.js.map